var __TEMP__ = require('./identity.js');var identity = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_overRest.js');var overRest = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_setToString.js');var setToString = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = baseRest;
